import { Box, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import React from "react";

import styles from "../styles";

interface StyledDialogTitleProps {
  title: string | React.ReactElement;
  leftAction?: React.ReactElement;
  rightAction?: React.ReactElement;
  handleClose?: () => void;
  centered?: boolean;
}

export default function StyledDialogTitle({
  title,
  leftAction,
  rightAction,
  handleClose,
  centered = false,
}: StyledDialogTitleProps) {
  return (
    <DialogTitle>
      <Grid container alignItems="center" justifyContent="space-between">
        {leftAction && <Box sx={styles.actionButton}>{leftAction}</Box>}
        {!leftAction && centered && <Grid item />}
        <Typography
          variant="h4"
          sx={styles.title}
          textAlign={centered ? "center" : "left"}
        >
          {title}
        </Typography>
        {rightAction ? (
          <Box
            sx={[
              styles.actionButton,
              { display: "flex", justifyContent: "flex-end" },
            ]}
          >
            {rightAction}
          </Box>
        ) : (
          <Box>
            <IconButton onClick={handleClose} sx={{ height: 40, width: 40 }}>
              <Box
                component={"i"}
                className="fa-regular fa-xmark"
                sx={{ color: grey[400] }}
              />
            </IconButton>
          </Box>
        )}
      </Grid>
    </DialogTitle>
  );
}
